import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const SubtractMinusIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.6663 7.5C12.9425 7.5 13.1663 7.72386 13.1663 8C13.1663 8.27614 12.9425 8.5 12.6663 8.5H3.33334C3.05719 8.5 2.83334 8.27614 2.83334 8C2.83334 7.72386 3.05719 7.5 3.33334 7.5H12.6663Z"
      fill="currentColor"
    />
  </svg>
);
